import * as R from 'ramda'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'

import { noneOf } from './none-of'

const numberOrString = PropTypes.oneOfType([PropTypes.number, PropTypes.string])

function padding(...propNames) {
  return props => {
    const propName = R.find(propName => R.has(propName, props), propNames)
    const propValue = props[propName]
    const value = R.path(['paddings', propValue], props.theme) || propValue
    const hasUnit = parseFloat(value) != value
    return hasUnit ? value : `${value}px`
  }
}

/**
 * Render children with whitespace around
 * @param {Object} props
 * @param {(number|string)} [props.all] Add whitespace at all sides
 * @param {(number|string)} [props.x] Add whitespace on left and right sides
 * @param {(number|string)} [props.y] Add whitespace at top and bottom
 * @param {(number|string)} [props.left] Add whitespace on left side
 * @param {(number|string)} [props.right] Add whitespace on right side
 * @param {(number|string)} [props.top] Add whitespace at the top
 * @param {(number|string)} [props.bottom] Add whitespace at the bottom
 * @returns {ReactComponent}
 */
export const Space = styled('div', {
  shouldForwardProp: noneOf([
    'all',
    'as',
    'bottom',
    'left',
    'right',
    'top',
    'x',
    'y',
  ]),
})`
  padding-top: ${padding('top', 'y', 'all')};
  padding-bottom: ${padding('bottom', 'y', 'all')};
  padding-right: ${padding('right', 'x', 'all')};
  padding-left: ${padding('left', 'x', 'all')};
`

Space.propTypes = {
  all: numberOrString,
  bottom: numberOrString,
  left: numberOrString,
  right: numberOrString,
  top: numberOrString,
  x: numberOrString,
  y: numberOrString,
}
